import React from 'react'
import {withRouter} from 'react-router-dom'
import {withTranslation} from 'react-i18next'
import {ArrowLeftOutlined, ShoppingCartOutlined} from '@ant-design/icons'

import BButton from 'components/Form/Fields/BButton'
import useCartContext from 'components/Cart/useCartContext'

const AppHeaderCheckout = ({history, t}) => {
  const {cart} = useCartContext()

  return (
    <nav id='navCheckout'>
      <div id='nav-logo'><span/></div>

      <div id='navCheckout-controls'>
        <BButton white bordered onClick={_ => history.goBack()} className='navBackButton'>
          <ArrowLeftOutlined/> {t('back to shopping')}
        </BButton>

        <div className='navIcons'>
          <div>
            <span><b>{t('{{count}} item', {count: Object.keys(cart.items).length})}</b></span>
            <span>in your basket</span>
          </div>
          <div>
            <ShoppingCartOutlined/>
          </div>
        </div>
      </div>
    </nav>
  )
}

export default withRouter(withTranslation()(AppHeaderCheckout))
